'use strict';

require('./build/buildDateRangeUnitsCall');

// This package does not export anything as it is
// simply defining "seconds" on Range.prototype.


// WEBPACK FOOTER //
// ./~/sugar-date/range/seconds.js